/* eslint-disable @typescript-eslint/naming-convention */
import {Injectable} from '@angular/core';
import {CommandMap, CommandsDescriptor} from '@app/models/commands/commands-descriptor';
import {MessageRecord} from '@app/services/data.service';
import {WrtcService} from '@app/modules/wrtc/services/wrtc.service';
import {Store} from '@ngxs/store';
import {ExecBuffer} from '@app/models/exec-buffer';

export enum WRTCEvents {
  RELOAD_USER = 'RELOAD_USER',
  RESET = 'RESET',
  WAKEUP_SIGNAL = 'WAKEUP_SIGNAL',
}

export enum WRTCStates {
  SELF_MUTE_AUDIO = 'SELF_MUTE_AUDIO',
  MUTE_AUDIO = 'MUTE_AUDIO',
  UNMUTE_AUDIO = 'UNMUTE_AUDIO',
  MUTE_VIDEO = 'MUTE_VIDEO',
  UNMUTE_VIDEO = 'UNMUTE_VIDEO',
  ROOM_AUDIO = 'ROOM_AUDIO',
  PRIVATE_WHITEBOARD = 'PRIVATE_WHITEBOARD',
  PRIVATE_TALK = 'PRIVATE_TALK',
  END_PRIVATE_TALK = 'END_PRIVATE_TALK',
  EXCLUDE_FROM_PRIVATE_TALK = 'EXCLUDE_FROM_PRIVATE_TALK',
  TEACHER_IN_TEAM = 'TEACHER_IN_TEAM',
  FRAME_RATE = 'FRAME_RATE',
  RESOLUTION = 'RESOLUTION',
  MIC_ACCESS_DENIED = 'MIC_ACCESS_DENIED',
  MIC_ACCESS_GRANTED = 'MIC_ACCESS_GRANTED',
  CAMERA_ACCESS_DENIED = 'CAMERA_ACCESS_DENIED',
  CAMERA_ACCESS_GRANTED = 'CAMERA_ACCESS_GRANTED',
  VOICE_LEVEL = 'VOICE_LEVEL',
}


@Injectable({
  providedIn: 'root'
})
export class WRTCCommands extends CommandsDescriptor<WRTCEvents, WRTCStates> {

  static category = 'WRTC';

  constructor(private wrtcService: WrtcService, store: Store) {

    const MAP: CommandMap<WRTCEvents, WRTCStates> = {
      EVENT: {
        RELOAD_USER:  (record: MessageRecord) => this.wrtcService.onReload(record),
        RESET:  (record: MessageRecord) => this.wrtcService.onReset(record),
        WAKEUP_SIGNAL: (record: MessageRecord) => this.wrtcService.onWakeUpSignal(record)
      },
      STATE: {
        SELF_MUTE_AUDIO: (record: MessageRecord) => this.wrtcService.onSelfAudioMute(record),
        MUTE_AUDIO: (record: MessageRecord) => this.wrtcService.onAudioMute(record),
        UNMUTE_AUDIO: (record: MessageRecord) => this.wrtcService.onAudioUnmute(record),
        MUTE_VIDEO: (record: MessageRecord) => this.wrtcService.onVideoMute(record),
        UNMUTE_VIDEO: (record: MessageRecord) => this.wrtcService.onVideoUnmute(record),
        ROOM_AUDIO: (record: MessageRecord) => this.wrtcService.onMuteRoom(record),
        PRIVATE_WHITEBOARD: (record: MessageRecord) => this.wrtcService.onPrivateWhiteboardState(record),
        PRIVATE_TALK: (record: MessageRecord) => this.wrtcService.onPrivateTalk(record),
        END_PRIVATE_TALK: (record: MessageRecord) => this.wrtcService.onEndPrivateTalk(record),
        EXCLUDE_FROM_PRIVATE_TALK: (record: MessageRecord) => this.wrtcService.onExcludeFromPrivateTalk(record),
        TEACHER_IN_TEAM: (record: MessageRecord) => this.wrtcService.onTeacherTeam(record),
        FRAME_RATE: (record: MessageRecord) => this.wrtcService.onFrameRate(record),
        RESOLUTION: (record: MessageRecord) => this.wrtcService.onResolution(record),
        MIC_ACCESS_DENIED: (record: MessageRecord) => this.wrtcService.onMicAccessDenied(record),
        MIC_ACCESS_GRANTED: (record: MessageRecord) => this.wrtcService.onMicAccessGranted(record),
        CAMERA_ACCESS_DENIED: (record: MessageRecord) => this.wrtcService.onWebCamAccessDenied(record),
        CAMERA_ACCESS_GRANTED: (record: MessageRecord) => this.wrtcService.onWebCamAccessGranted(record),
        VOICE_LEVEL: (record: MessageRecord) => this.wrtcService.onVoiceLevel(record),
      }
    };
    super(MAP, new ExecBuffer(true), store);
    this.wrtcService.handleRecordStack = this.handleRecordStack.bind(this);
  }
}
